import '../index.scss';

import { CSSProperties, PropsWithChildren, forwardRef } from 'react';

export interface RibbonContainerProps {
  orientation?: 'horizontal' | 'vertical';
  style?: CSSProperties;
  className?: string;
}

export const RibbonContainer = forwardRef<HTMLDivElement, PropsWithChildren<RibbonContainerProps>>(
  function RibbonContainer({ orientation = 'horizontal', style, className, children }, ref) {
    return (
      <div ref={ref} style={style} className={className}>
        <div className={`RibbonButton-${orientation}Group`}>{children}</div>
      </div>
    );
  },
);
